/**
 * PATCH `admin/clients/:id` — правка «Основного» и заметок клиента.
 * Передаются только изменённые поля; город и специализация в UI живут
 * именами — в id их переводят справочники.
 */

import {apiEnabled, http} from '@services/utils';
import {toE164} from '@utils/phone';

import {patchDetailMock} from '../detailMocks';
import {getCities} from '../getCities';
import {getSpecializations} from '../getSpecializations';
import {MOCK_CLIENTS} from '../mocks';

export type UpdateClientInput = {
  id: string;
  name?: string;
  address?: string;
  /** Имя города из справочника */
  city?: string;
  /** «Русский» | «Кыргызча» */
  language?: string;
  businessPhone?: string;
  notes?: string;
  adminFullName?: string;
  /** Имя специализации из справочника (соло) */
  specialization?: string;
};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const updateClient = async (input: UpdateClientInput): Promise<{ok: true}> => {
  if (!apiEnabled) {
    await sleep(300);
    const row = MOCK_CLIENTS.find((c) => c.id === input.id);
    if (row) {
      if (input.name !== undefined) row.name = input.name;
      if (input.city !== undefined) row.cityName = input.city;
      if (input.adminFullName !== undefined) row.adminFullName = input.adminFullName;
    }
    patchDetailMock(input.id, {
      ...(input.address !== undefined ? {address: input.address} : {}),
      ...(input.language !== undefined ? {language: input.language} : {}),
      ...(input.businessPhone !== undefined
        ? {businessPhone: input.businessPhone ? `+996 ${input.businessPhone}` : null}
        : {}),
      ...(input.notes !== undefined ? {notes: input.notes} : {}),
      ...(input.specialization !== undefined ? {specialization: input.specialization} : {}),
    });
    return {ok: true};
  }

  const cityId = input.city
    ? ((await getCities()).find((c) => c.name === input.city)?.id ?? null)
    : undefined;
  const specializationId = input.specialization
    ? ((await getSpecializations()).find((s) => s.name === input.specialization)?.id ?? null)
    : undefined;

  await http(`admin/clients/${encodeURIComponent(input.id)}`, {
    method: 'PATCH',
    body: {
      ...(input.name !== undefined ? {name: input.name} : {}),
      ...(input.address !== undefined ? {address: input.address} : {}),
      ...(cityId !== undefined ? {cityId} : {}),
      ...(input.language !== undefined
        ? {language: input.language === 'Кыргызча' ? 'kg' : 'ru'}
        : {}),
      ...(input.businessPhone !== undefined
        ? {businessPhone: input.businessPhone ? toE164(input.businessPhone) : null}
        : {}),
      ...(input.notes !== undefined ? {notes: input.notes} : {}),
      ...(input.adminFullName !== undefined ? {adminFullName: input.adminFullName} : {}),
      ...(specializationId !== undefined ? {specializationId} : {}),
    },
    skipCaseConversion: true,
  });
  return {ok: true};
};
